export default __webpack_public_path__ + "static/media/ourMission1.dc1bea68.png";